import { __decorate } from "tslib";
import { property, query } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
export class Label extends LitElement {
    constructor() {
        super(...arguments);
        this.top = false;
    }
    render() {
        return html `
            <label @click="${this.clickEvent}" ?top="${this.top}">
                <slot></slot>
            </label>
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this._label.setAttribute('for', this.for);
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('top')) {
            this.top ? this.classList.add('top') : this.classList.remove('top');
        }
    }
    clickEvent(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.dispatchEvent(new Event('click'));
    }
}
Label.styles = css `
        :host(:focus-visible),
        label:focus-visible {
            outline: 0;
        }

        :host {
            margin: var(--ep-label-margin, 0);
            padding: var(--ep-label-padding, 0 0 0 10px);
            flex: var(--ep-label-flex);
            display: inline-block;
        }

        :host(.top) {
            display: block;
            padding: var(--ep-label-padding, 0);
        }

        label {
            color: var(--ep-label-text-color, var(--ep-text-color));
            cursor: var(--ep-label-cursor, pointer);
            font-size: var(--ep-label-text-font-size, var(--ep-text-font-size));
            font-family: var(--ep-text-font-family);
            font-weight: var(--ep-label-text-font-weight, var(--ep-text-font-weight));
            line-height: var(--ep-label-line-height, 1);
        }

        ::slotted(*) {
            display: none;
        }

        ::slotted(input),
        ::slotted(textarea),
        ::slotted(ep-input),
        ::slotted(ep-textarea) {
            display: inline-block;
        }

        :host(.va) label {
            vertical-align: top;
        }
    `;
__decorate([
    property()
], Label.prototype, "for", void 0);
__decorate([
    property({ type: Boolean })
], Label.prototype, "top", void 0);
__decorate([
    query('label')
], Label.prototype, "_label", void 0);
if (!customElements.get('ep-label')) {
    customElements.define('ep-label', Label);
}
//# sourceMappingURL=element.js.map